export default {"src":"/_next/static/media/skilledTech.bb2b6e8f.svg","height":103,"width":93,"blurWidth":0,"blurHeight":0};